"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserState = exports.selectableRolesForUpdateUser = exports.roles = void 0;
exports.roles = [
    'unauthorized',
    'alternative-contact',
    'debtor',
    'client',
    'caseworker',
    'admin',
    'super-admin',
];
exports.selectableRolesForUpdateUser = exports.roles
    .filter((r) => ['client', 'caseworker', 'admin'].includes(r))
    .map((r) => r);
var UserState;
(function (UserState) {
    UserState["ACTIVE"] = "ACTIVE";
    UserState["DELETED"] = "DELETED";
})(UserState || (exports.UserState = UserState = {}));
//# sourceMappingURL=index.js.map